import styled, { css } from 'styled-components';
import { useState } from 'react';
import { CountdownAnimation } from './CountdownAnimation';
import Tooltip from 'components/Tooltip';
import { useSoundRecordingContext } from './context';
import { SoundIcon } from 'pages/CreateVehicle/icons/SoundIcon';
import { SoundRecorderDialog } from './SoundRecorderDialog';
import { useVehicleEditing } from 'context/isAnotherUserEditingContext';

const disabledCss = css`
  opacity: 0.7;
  pointer-events: none;
`;

const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  ${props => props.disabled && disabledCss}
`;

export const SoundRecorder = () => {
  const [iconHovered, setIconHovered] = useState(false);

  const {
    isRecording,
    finishRecording,
    startRecordingCountdown,
    startRecording,
    shouldRenderCountdown,
    stopCountdown
  } = useSoundRecordingContext();

  const { hasAnotherEditor } = useVehicleEditing();

  return (
    <>
      <Tooltip title={isRecording ? 'Stop Recording' : 'Start Recording'} isTextOverflown titleStyle="uploadVehicle">
        <Wrapper
          disabled={hasAnotherEditor}
          onMouseOut={() => setIconHovered(false)}
          onMouseOver={() => setIconHovered(true)}
          onClick={isRecording ? finishRecording : startRecordingCountdown}
        >
          <SoundIcon active={iconHovered || isRecording} />
        </Wrapper>
      </Tooltip>

      <CountdownAnimation onClose={startRecording} shouldRender={shouldRenderCountdown} stopRendering={stopCountdown} />
    </>
  );
};
